import script from "./ProductSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSearch.vue?vue&type=script&setup=true&lang=js"

import "./ProductSearch.vue?vue&type=style&index=0&id=8845f75c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8845f75c"]])

export default __exports__